export const FETCH_DASHBOARD_CATEGORY_REQUEST = 'FETCH_DASHBOARD_CATEGORY_REQUEST';
export const FETCH_DASHBOARD_CATEGORY_SUCCESS = 'FETCH_DASHBOARD_CATEGORY_SUCCESS';
export const FETCH_DASHBOARD_CATEGORY_FAILURE = 'FETCH_DASHBOARD_CATEGORY_FAILURE';
